
import { toast } from '@/utils/common';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import UploadFile from './FileUpload/upload.vue';
@Component({
  components: { UploadFile },
})
export default class extends Vue {
  @Prop() visible!: boolean;
  @Prop() isUpload!: number;
  @Prop() desc!: string;
  @Prop() errData!: object;
  newDesc: string = '';
  file: any;
  @Prop() loading: boolean = false;
  @Emit() close() {}
  handleCommit() {
    if (this.isUpload) {
      if (!this.file) {
        toast('请导入兑换码！', 'error');
        return;
      } else {
        this.$emit('thirdCodeCommit', this.file, this.isUpload);
      }
    } else {
      if (this.newDesc.trim() == '') {
        toast('请输入使用说明', 'error');
        return;
      } else {
        this.$emit('thirdCodeCommit', this.newDesc, this.isUpload);
      }
    }
  }
  upLoadSuccess(file: any) {
    this.file = file;
  }
  mounted() {
    this.newDesc = this.desc;
  }
}
